import { Injectable } from '@angular/core';
import axios from 'axios';
import { environment } from 'src/environments/environment';
import { ClientDataTableItem } from '../clients/clients.service';

export type AddCreditRequest = {
  amount: number;
  currency_iso: string;
};

@Injectable({
  providedIn: 'root'
})
export class CreditsService {
  async toggleAutoStartHard2(client_id: string, auto_start_hard_2: boolean): Promise<void> {
    await axios.post(
      `${environment.baseUrl}/api/client-credit/${client_id}/toggle-auto-start-hard2`,
      {
        auto_start_hard_2,
      },
    );
  }

  async toggle(client_id: string, uses_credits: boolean): Promise<void> {
    await axios.post(
      `${environment.baseUrl}/api/client-credit/${client_id}/toggle`,
      {
        uses_credits,
      },
    );
  }

  async add(client_id: string, params: AddCreditRequest): Promise<ClientDataTableItem> {
    const result = await axios.post<{ client: ClientDataTableItem; }>(
      `${environment.baseUrl}/api/client-credit/${client_id}/add`,
      params,
    );

    return result.data.client;
  }

  async pay(client_id: string, credit_transfer_id: string): Promise<ClientDataTableItem> {
    const result = await axios.post<{ client: ClientDataTableItem; }>(
      `${environment.baseUrl}/api/client-credit/${client_id}/pay/${credit_transfer_id}`,
    );

    return result.data.client;
  }
}
